class GlobalState {
  static init() {
    if (typeof global.gon === "undefined") {
      global.gon = {};
    }

    if (typeof global.gon.state === "undefined") {
      global.gon.state = {};
    }

    if (typeof global.gon.state.callbacks === "undefined") {
      global.gon.state.callbacks = {};
    }
  }

  static has(key) {
    return typeof global.gon.state[key] !== "undefined";
  }

  static get(key) {
    if (GlobalState.has(key)) {
      return global.gon.state[key];
    }

    return null;
  }

  static set(key, value) {
    global.gon.state[key] = value;
  }

  static registerCallback(name, callback) {
    const callbacks = GlobalState.get("callbacks");

    if (typeof callbacks[name] === "undefined") {
      callbacks[name] = [];
    }

    callbacks[name].push(callback);

    GlobalState.set("callbacks", callbacks);
  }

  static removeCallback(name, callback) {
    const callbacks = GlobalState.get("callbacks");

    if (typeof callbacks[name] !== "undefined") {
      const index = callbacks[name].indexOf(callback);

      if (index > -1) {
        callbacks[name].splice(index, 1);
      }
    }

    GlobalState.set("callbacks", callbacks);
  }

  static hasCallbacks(name) {
    const callbacks = GlobalState.get("callbacks");

    if (typeof callbacks[name] !== "undefined") {
      return true;
    }

    return false;
  }

  static runCallbacks(name) {
    const callbacks = GlobalState.get("callbacks");

    if (typeof callbacks[name] === "undefined") {
      return false;
    }

    callbacks[name].map(callback => callback());

    return true;
  }
}

GlobalState.init();

export default GlobalState;
